import { useCallback, type FC } from 'react';
import type { ControlProps } from '../props';
import { FileInput, useToasts, type Nullable } from '@synqo/frontend-component-library';

export const FileInputControl: FC<ControlProps> = ({ data: apiCustomization, locked, updateData }) => {
    const { pushToast } = useToasts();

    const uploadFile = useCallback(
        (file: File) => {
            updateData({
                id: apiCustomization.id,
                value: 'local-id-' + Math.random(),
                source: file.name,
                file: file,
            });
        },
        [updateData, apiCustomization],
    );

    const removeFile = useCallback(() => {
        updateData({
            id: apiCustomization.id,
            value: '',
            source: '',
            file: undefined,
        });
    }, [updateData, apiCustomization]);

    const handleFilePick = useCallback(
        (file: Nullable<File>) => {
            if (!file) {
                removeFile();
                return;
            }

            // file size > 10 MiB
            if (file.size > 10 * 1024 * 1024) {
                pushToast({
                    title: 'Information',
                    message: 'Bilddateien dürfen maximal 10MB groß sein.',
                    variant: 'info',
                    timeout: 10_000,
                });
                return;
            }

            uploadFile(file);
        },
        [pushToast, uploadFile, removeFile],
    );

    return (
        <FileInput
            label={apiCustomization.label}
            name={apiCustomization.name}
            value={apiCustomization.source}
            accept="image/*"
            placeholder="Datei hochladen"
            onChange={handleFilePick}
            locked={locked}
        />
    );
};
